/**
 * say hello
 *
 * @param name - input name
 * @returns hello message
 *
 * @alpha
 */
export const hello = (name: string): string => {
  return `hello ${name}`;
};
